$(function() {
    $('.del').click(function(e){
        e.preventDefault();
        $('#confirmModal').modal('show');
        var link = $(this).attr('href');
        $('#delete').click(function(){
            window.location.href = link;
        });
    });
});

$(function() {
    $('.send').click(function(e){
        e.preventDefault();
        $('#sendConfirmModal').modal('show');
        var link = $(this).attr('href');
        $('#send').click(function(){
            $('#send').addClass('disabled');
            window.location.href = link;
        });
    });
});